import { Component } from '@angular/core';
import { GlobalService } from '../global.service';
import { CignalService } from '../cignal.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  total_revenue: string = "...";
  monthly_sales: string = "...";
  weekly_sales: string = "...";

  constructor(
    private globalService: GlobalService,
    private cignalService: CignalService,
  ){}
  
  ngOnInit(){
    this.getTotalRevenue()
  }

  async getTotalRevenue(){
    this.total_revenue = '₱'+this.globalService.numberWithCommas( await this.cignalService.getTotalRevenue() );
    this.monthly_sales = '₱'+this.globalService.numberWithCommas( await this.cignalService.getMonthlySales() );
    this.weekly_sales = '₱'+this.globalService.numberWithCommas( await this.cignalService.getWeeklySales() );
  }

}
